// extracted by mini-css-extract-plugin
export default {"container":"AGB_container__A96-I","card":"AGB_card__5nuwt","content":"AGB_content__swR3Z"};